import React from 'react';
import useTranslate from '../../../../../../customHooks/useTranslate';
import Icon from '../../../../../../muiComponents/Icon';

const NoServicesInSection = () => {
    const translate = useTranslate();

    return (
        <div className='competitor-viewer__no-services-in-section'>
            <div className='competitor-viewer__no-services-in-section__icon'>
                <Icon iconName='SearchOff' aria-hidden='true' />
            </div>
            <h3 className='competitor-viewer__no-services-in-section__title'>
                {translate('no_services_in_section')}
            </h3>
            <p className='competitor-viewer__no-services-in-section__description'>
                {translate('no_services_in_section_description')}
            </p>
        </div>
    );
};

export default NoServicesInSection;
